/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';
import { IVisitor } from '../../visitors/IVisitor';
import { Contact } from './Contact';
import { License } from './License';

/**
 * Constructor.
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export abstract class Info extends ExtensibleNode {
    public title : string;

    public description : string;

    public termsOfService : string;

    public contact : Contact;

    public license : License;

    public version : string;

    public constructor() {
        super();
        if(this.title===undefined) this.title = null;
        if(this.description===undefined) this.description = null;
        if(this.termsOfService===undefined) this.termsOfService = null;
        if(this.contact===undefined) this.contact = null;
        if(this.license===undefined) this.license = null;
        if(this.version===undefined) this.version = null;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitInfo(this);
    }

    /**
     * Creates a Contact node.
     * @return {Contact}
     */
    public abstract createContact() : Contact;

    /**
     * Creates a License node.
     * @return {License}
     */
    public abstract createLicense() : License;
}
Info["__class"] = "io.apicurio.datamodels.core.models.common.Info";
Info["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




